import translations from '@/translations/translations.json'

const languages = {
  en_GB: 'English',
  ro_RO: 'Romanian'
}

const translateConfig = {
  availableLanguages: languages,
  defaultLanguage: 'ro_RO',
  translations: translations,
  silent: true
}

const veeValidateLangMapping = {
  en_GB: 'en',
  ro_RO: 'ro'
}

export { translateConfig, veeValidateLangMapping }
